module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-mask-1.c47bb344.png";